var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconEditedBy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    fill: "none",
    viewBox: "0 0 31 31",
    id: "svg3",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#000000",
      strokeWidth: 1.45146,
      strokeLinecap: "round"
    },
    d: "M 3.6332661,19.857665 C 3.1734709,18.488988 2.9243117,17.023591 2.9243117,15.5 c 0,-7.5525592 6.1224965,-13.6751176 13.6749783,-13.6751173 7.552482,-6e-7 13.674979,6.1225578 13.674979,13.6751173 0,7.552558 -6.122497,13.675117 -13.674979,13.675117 -2.373692,0 -4.606127,-0.604787 -6.551627,-1.668675",
    id: "path3"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000",
      strokeWidth: 1.14996,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    d: "M 5.9025457,15.573537 C 5.6975854,15.307856 5.3663685,15.171821 5.033836,15.216749 L 2.9243117,15.5 0.81478625,15.783249 c -0.71638114,0.09607 -1.05980683,0.931897 -0.61791877,1.503883 l 1.29989282,1.684539 1.299893,1.684539 c 0.4407395,0.573567 1.337314,0.453907 1.6122055,-0.215172 l 0.8078718,-1.969184 0.8096322,-1.967791 c 0.1279691,-0.310016 0.080766,-0.664759 -0.1238171,-0.930526 z",
    id: "path4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g1",
    transform: "translate(0.10092885,-0.94221063)"
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#000000",
      strokeWidth: 6.42553,
      strokeLinecap: "square",
      strokeLinejoin: "round",
      paintOrder: "markers fill stroke"
    },
    id: "path1",
    cx: 16.498362,
    cy: 10.543503,
    r: 3.0195329
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect1",
    style: {
      fill: "#000000",
      strokeWidth: 4.896,
      strokeLinecap: "square",
      strokeLinejoin: "round",
      strokeDasharray: "none",
      paintOrder: "markers fill stroke"
    },
    d: "m 14.806669,14.571752 h 3.383385 a 4.4383083,4.4383083 45 0 1 4.438308,4.438308 v 4.318742 a 0.91074587,0.91074587 135 0 1 -0.910746,0.910746 H 11.279107 A 0.91074587,0.91074587 45 0 1 10.368361,23.328802 V 19.01006 a 4.4383083,4.4383083 135 0 1 4.438308,-4.438308 z",
    transform: "matrix(1,0,0,1.115942,0,-1.6894786)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEditedBy);
export default __webpack_public_path__ + "static/media/icon_edited_by.1ab0dfe80ce716d29548d45821ba29b1.svg";
export { ForwardRef as ReactComponent };